import jsonFetch from '../util/jsonFetch';

export default async ({ isbn }) => {
  const url = `${__API_BASE__}/open/products?isbn=${isbn}`;
  const response = await jsonFetch('ltiFindProduct', [url], false);

  return response;
};
